import styled from "styled-components";
import { Typography } from "@mui/material";

export const StyledTextError = styled(Typography)`
  padding: 0 10px;
  margin-top: 8;
`;
